/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Team_Active_LabelInputs */

const en_team_active_label = /** @type {(inputs: Team_Active_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`active`)
};

const es_team_active_label = /** @type {(inputs: Team_Active_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`activo`)
};

const fr_team_active_label = /** @type {(inputs: Team_Active_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`actif`)
};

const de_team_active_label = /** @type {(inputs: Team_Active_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`aktiv`)
};

const id_team_active_label = /** @type {(inputs: Team_Active_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`aktif`)
};

/** @type {(inputs: Team_Active_LabelInputs) => LocalizedString} */
const ja_team_active_label = en_team_active_label;

/** @type {(inputs: Team_Active_LabelInputs) => LocalizedString} */
const zh_team_active_label = en_team_active_label;

/** @type {(inputs: Team_Active_LabelInputs) => LocalizedString} */
const ar_team_active_label = en_team_active_label;

/** @type {(inputs: Team_Active_LabelInputs) => LocalizedString} */
const it_team_active_label = en_team_active_label;

/** @type {(inputs: Team_Active_LabelInputs) => LocalizedString} */
const ru_team_active_label = en_team_active_label;

/** @type {(inputs: Team_Active_LabelInputs) => LocalizedString} */
const pt_team_active_label = en_team_active_label;

/** @type {(inputs: Team_Active_LabelInputs) => LocalizedString} */
const ko_team_active_label = en_team_active_label;

/**
* | output |
* | --- |
* | "active" |
*
* @param {Team_Active_LabelInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const team_active_label = /** @type {((inputs?: Team_Active_LabelInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Team_Active_LabelInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_team_active_label(inputs)
	if (locale === "es") return es_team_active_label(inputs)
	if (locale === "fr") return fr_team_active_label(inputs)
	if (locale === "de") return de_team_active_label(inputs)
	if (locale === "ja") return ja_team_active_label(inputs)
	if (locale === "zh") return zh_team_active_label(inputs)
	if (locale === "ar") return ar_team_active_label(inputs)
	if (locale === "id") return id_team_active_label(inputs)
	if (locale === "it") return it_team_active_label(inputs)
	if (locale === "ru") return ru_team_active_label(inputs)
	if (locale === "pt") return pt_team_active_label(inputs)
	return ko_team_active_label(inputs)
});